import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import { useSearchParams } from "react-router-dom";
import AuthLayout from "../components/AuthLayout";
import { Alert, Input, buttonClass } from "../components/ui";

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.post("/auth/reset-password", {
        token: token,
        password: password,
      });
      setMessage("Password successfully reset");
      setLoading(false);
      navigate("/login");
    } catch (err) {
      setLoading(false);
      if (err.response.status === 400) {
        setErrorMessage(err.response.data.message);
        return;
      }
      setErrorMessage("There was a problem resetting your password");
    }
  };

  return (
    <AuthLayout title="Set a new password" subtitle="Please set your new password.">
      {message && <Alert tone="success" className="mb-4">{message}</Alert>}
      {errorMessage && <Alert tone="error" className="mb-4">{errorMessage}</Alert>}

      <form onSubmit={handleSubmit} className="space-y-3">
        <Input
          type="password"
          placeholder="Enter new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <Input
          type="password"
          placeholder="Confirm new password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button className={buttonClass({ className: "w-full" })} disabled={loading}>
          {loading ? "Sending…" : "Reset Password"}
        </button>
      </form>

      <p className="mt-5 text-center text-sm text-gray-500 dark:text-slate-400">
        Back to{" "}
        <a
          href="/login"
          className="font-semibold text-red-600 transition hover:text-red-500 dark:text-orange-400"
        >
          Login
        </a>
      </p>
    </AuthLayout>
  );
}

export default ResetPassword;
